import uuid from "@pdfking/workflow/utils/uuid"

import navigate from "../routes/navigate"
import { PROMPT_VIEW } from "../routes/urls"

// Store for resolving/rejecting promises
const pending_dialogs = new Map<
  string,
  {
    resolve: (value: null | string) => void
    reject: (reason?: any) => void
  }
>()

// Event listener for dialog results
document.addEventListener("alert-dialog-result", ((e: CustomEvent) => {
  const { id, result } = e.detail
  const dialog = pending_dialogs.get(id)

  if (dialog) {
    dialog.resolve(result)
    pending_dialogs.delete(id)
  }
}) as EventListener)

/**
 * Shows a confirmation dialog with custom buttons
 * @param message The message to display in the dialog
 * @param buttons Record of button keys to button labels (e.g., { abort: 'Cancel', confirm: 'OK' })
 * @param default_button The key of the button to style as primary (defaults to last button)
 * @returns Promise that resolves with the key of the button pressed, or null if dialog was closed
 */
export default (
  message: string,
  buttons: Record<string, string>,
  default_button?: string
): Promise<null | string> => {
  return new Promise((resolve, reject) => {
    // Generate unique ID for this dialog
    const id = uuid()

    // Store the promise handlers
    pending_dialogs.set(id, { resolve, reject })

    // Navigate to prompt view with parameters
    navigate(PROMPT_VIEW, {
      id,
      message,
      buttons,
      default_button,
    })
  })
}
